import { render } from "./CadastrarUsuario.vue?vue&type=template&id=03f7062d&scoped=true"
import script from "./CadastrarUsuario.vue?vue&type=script&lang=js"
export * from "./CadastrarUsuario.vue?vue&type=script&lang=js"

import "./CadastrarUsuario.vue?vue&type=style&index=0&id=03f7062d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f7062d"]])

export default __exports__